export default class TermsApi {

  fetchTermsForPack(packName) {

    let request = new Request(`/questions/get/${packName}`, { 
      method: 'GET',
      headers: new Headers({ 
        'X-Requested-With': 'XMLHttpRequest', 
        'apiKey': '7e93a522-17f0-4789-930c-a5f3b4c1acfd' 
      }),
      mode: 'cors',
      cache: 'default' 
    });

    return this.serverRequest = fetch(request).then(response => {
      return response.json();
    }).then(termsList => {
      return termsList;
    });
  }

  terminateRequest() {
    this.serverRequest.abort();
  }
}


// WEBPACK FOOTER //
// ./src/components/pack-session/terms-api.js